import { render, staticRenderFns } from "./person-greeting-card.vue?vue&type=template&id=4dab6e60&"
import script from "./person-greeting-card.vue?vue&type=script&lang=js&"
export * from "./person-greeting-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports